import adminApiClient from './apiClient.js';

export const authApi = {
  login: async (email, password) => {
    const { data } = await adminApiClient.post('/admin-auth/login', { email, password });
    return data;
  },
  me: async () => {
    const { data } = await adminApiClient.get('/admin-auth/me');
    return data;
  },
};

export default authApi;
